const en_US = {
    'title': 'Quancept: automated trading platform for stock, options, futures, crypto. provide market scanner, filter, streaming alerts, strategy trading EMS, fully automated strategy trading, NLP scan, language understanding scan',
    'keywords': 'stock, scanner, filter, automated trading, NLP, language driven, language understanding, AI strategy,AI model,verbal command,profit target, stop loss, time exit, personalized condition, custom logic, no-code, low-code, platform, portfolio backtest, fast backtest, algorithm backtesting, algorithmic trading, algo model, learn algo trading, quant, quant research, strategy design, trading strategy, algo platform',
    'description': 'Quancept, powerful low-code/no-code tick-by-tick market filter,scanner, empower traders to discover, capture, monetize trading opportunities in real time across the entire market, define and execute trading strategy with ease of use and flexibility',

    'vernacular title': 'Quancept: automated trading platform for stock, options, futures, crypto. provide market scanner, filter, streaming alerts, strategy trading EMS, fully automated strategy trading, NLP scan, language understanding scan',
    'vernacular keywords': 'stock, scanner, filter, automated trading, NLP, language driven, language understanding, AI strategy,AI model,verbal command,profit target, stop loss, time exit, personalized condition, custom logic, no-code, low-code, platform, portfolio backtest, fast backtest, algorithm backtesting, algorithmic trading, algo model, learn algo trading, quant, quant research, strategy design, trading strategy, algo platform',
    'vernacular description': 'Quancept, powerful low-code/no-code tick-by-tick market filter,scanner, empower traders to discover, capture, monetize trading opportunities in real time across the entire market, define and execute trading strategy with ease of use and flexibility',

    'intl.menu.home': 'Home',
    'intl.menu.usStocks': 'US STOCKS',
    'intl.menu.cnStocks': 'A STOCKS',
    'intl.menu.stockPicking': 'Scan',
    'intl.menu.strategyStockPicking': '策略库选股',
    'intl.menu.formulaStockPicking': '公式选股',
    'intl.menu.vernacularStockPicking': 'Scan',
    'intl.menu.newScan': 'New scan',
    'intl.menu.myStragegy': 'My scans',
    'intl.menu.customStock': 'My universe',
    'intl.menu.correlation': '相关性',
    'intl.menu.backtest': 'Backtest',
    'intl.menu.grid': 'Grid',
    'intl.menu.option': '期权',
    'intl.menu.factorService': '量化因子服务',
    'intl.menu.hawkeye': 'Monitor',
    'intl.menu.download': 'Download',
    'intl.menu.help': 'Help',
    'intl.menu.filter': 'Filter',
    'intl.menu.newFilter': 'New filter',
    'intl.menu.myFilter': 'My filter',
    'videoTutorial': 'Video',
    'pricing': 'Pricing',

    'title.newScan': 'Create custom stock scan',
    'title.newFilter': 'Streaming custom stock alerts',

    'description.scan': 'Scan for stocks based on price, volume and technical patterns on daily and intraday timeframes, cross timeframes and cross symbols',
    'description.filter': "Quancept's Filters deliver instant alerts for stock events, automating market tracking for traders.Stay ahead with seamless, real-time notifications.",


    'factorService': '因子服务',

    'intl.login': 'Login',
    'intl.logining': 'Logging in...',
    'intl.login.rememberMe': 'Remember me',
    'intl.login.forgotPassword': 'Forgot password？',
    'intl.login.verificationCodeLogin': 'Verification code login',
    'intl.login.userNameLogin': 'Password login',
    'email login':'Email login',

    'intl.register.phoneRegister': 'Mobile registration',
    'intl.register.emailRegister': 'Email registration',

    'intl.register.free': 'Register',
    'intl.login.immediately': 'Login immediately',
    'Login to existing quancept account': 'Login to existing quancept account',

    'intl.register': 'Register',
    'intl.registered': 'Registering',
    'intl.register.phone': 'Phone number',
    'intl.register.captcha': 'Verification code',
    'intl.register.getCaptcha': 'Get verification code',
    'intl.register.readAndAccept': 'I have read and hereby accept the',
    'intl.register.agreement': 'Agreement',

    'promo.code': 'Promo Code',
    'promoCode.format': 'Promo Code (7 Letters and Numbers)',
    'promoCode.required.format': 'Must contain one or more digit(s) and letter(s)',
    'promoCode.error': 'Does not exist or has expired',

    'intl.resetPassword': 'Reset Password',
    'intl.resetPasswording': 'Password resetting',

    'intl.youHaveRegisterSuccess': 'Congratulations！',
    'intl.register.openQuantitativeInvestment': 'A quantitative investment journey for you',

    'phone forget': 'Password reset',
    'email forget': 'Email password reset',
    'phone number and email address': 'Phone number and email address',

    'intl.forgetPasswordSuccess': 'Password has been reset',
    'intl.login.goToLogin': 'Please login',

    'optional': 'Optional',

    'intl.optionSymbol': '期权标的',
    'intl.scanStartEndDate': '扫描起止日',
    'intl.today': '今天',
    'intl.to': 'to',
    'intl.direction': '涨跌设置',
    'intl.strategyScan': '策略扫描',
    'intl.strategyScanning': '策略扫描中',

    'please.select.option.target': '请选择期权标的',
    'please.enter.scan.start.and.end.date': '请输入扫描起止日',
    'please.select.ups.and.downs.setting': '请选择涨跌设置',
    'rise': '上涨',
    'fall': '下跌',
    'riseTo': '上涨至',
    'fallTo': '下跌至',
    'please.select.ups.and.downs.setting.unit': '请选择涨跌设置单位',
    'price.difference': 'Price difference',

    'combination.name': '组合名称',
    'combination.details': '组合详情',
    'maxProfit': '最大收益',
    'maxRisk': '最大风险',
    'investment': '权利金支出/收入',
    'yieldToMaturity': '到期收益率(%)',
    'cost': '支出',
    'income': '收入',

    'option.scan.result': '根据参数设置，共扫描出 {num} 种期权策略组合',
    'combined.profit.and.loss.curve': '组合损益曲线',

    'company': '©Quancept {year} ',
    'about': 'About us',
    'contact': 'Contact us',
    'WeChat.public.number': 'WeChat Account',

    'about.info.01': 'The founding team of Quancept comes from JP Morgan Chase, Lehman Brothers, RBC Capital, Goldman Sachs and other well-known financial institutions on Wall Street, and has been strengthened by domestic stock market experts, data science artificial intelligence experts, and senior trading technology teams. Quancept focuses on securities technology and provides a quantitative investment research trading platform.The team is responsible for the design and development of various financial product transactions and risk control systems, to manage funds for quantitative transactions, and accumulate and create core products such as InSync and CrystalTrade.',
    'about.info.02': 'Quancept has 100% self-innovated CEP technology, many years of Wall Street\'s rich experience in trading and risk control system research and development and quantitative trading, the latest technology in artificial intelligence and machine learning, and market - wide Tick-level market data processing for securities firms, buyer institutions and individual investors Provide a one - stop complete solution.Investors can use natural language or Quancept\'s unique wizard-style simple functions and formulas without programming to complete strategy customization, debugging, trading and risk control rule editing, backtest verification, intelligent optimization, real-time operation, etc., to help users convenience and speed 3. Efficiently complete investment ideas and put them on the market.',
    'about.info.03': 'Quancept Stock Robot - Users can quickly complete the investment process such as stock selection, backtesting, optimization, and submitting orders via natural language on the app.',
    'about.info.04': '宽投的智能量化因子分析系统，使专业投资者的阿尔法因子探索简单化与系统化，短短几十分钟，就能在实时市场实现几十、上百个因子的探索、历史周期的因子文件生成、因子的单调性、自相关性、收益率、换手率、在各行业的表现等多维度的分析。',

    'contact.info.01': '',
    'contact.info.02': '',
    'contact.info.03': 'Email：support@quancept.com',
    'contact.info.04': '',

    'get.verification.code.failed': 'Verification code failed',
    'phone.not.register': 'Phone not registered',
    'format.failed': 'Wrong format',
    'phone.format.failed': 'Wrong format',
    'login.exception': 'Login abnormal',
    'account.not.register': 'Account not registered',
    'account.exception': 'Account abnormal',
    'password.or.verification.code.match.error': 'Password or verification code error',

    'email.registered': 'Email registered',
    'email.not.register': 'Email not registered',
    'email.format.failed': 'Wrong format',

    'Subscription.expired': 'Subscription expired',
    'user.account.has.expired': 'Login has expired, please contact customer service.',
    'account.not.expired': 'Account will expire in {num} days',
    'account.about.to.expire': 'Account is about to expire',

    'Service.not.operation': 'Service not in operation',

    'reset.password.success': 'Password has been reset.',
    'reset.password.exception': 'Password reset encountered error.',
    'verification.code.matching.error': 'Verification code incorrect.',

    'reset.password.failed': 'Password reset failed',

    'phone.is.register': 'Phone is registered',
    'register.success': 'Registration succeeded',
    'register.failed': 'Registration failed',
    'register.exception': 'Registration exception',
    'account.is.exist': 'Account already exists',

    'phone': 'Mobile number',
    'username/phone': 'Username/Mobile number',
    'account.password': 'Account password',

    'Verification code': 'Verification code',
    'phone.china.only': 'Mobile number',
    'phone.captcha': 'Verification code',
    'email.captcha': 'Verification code',
    'password.format': 'Password (6-16 characters, must contain at least one letter and one digit, case sensitive)',

    'phone.use.register': 'Phone number (the registration number)',
    'password.new.format': 'New password (6-16 characters, must contain at least one letter and one digit, case sensitive)',
    'password.old.format': 'Old password',


    'please.input.phone': 'Phone number',
    'please.input.captcha': 'Verification code',
    'please.input.password': 'Password',

    'please.input.username/phone': 'Username/mobile number',

    'password.min': 'Not less than 6 characters',
    'password.max': 'No more than 16 characters',
    'password.required.format': 'Must be numeric letters [case sensitive]',

    'email.min': 'Not less than 5 characters',
    'email.max': 'No more than 20 characters',

    'get.data.failed': 'Failed to retrieve data',
    'user.exception': 'Login does not exist or has expired',

    'function.not.open': 'Not yet open',

    'sequence': '#',

    'please go': 'Please go to ',
    //Scan
    'featured.strategy.directory': '精选策略目录',
    'my.formula.stock.picking.strategy': '我的公式选股策略',
    'strategy.items': 'Strategy List',
    'no.strategy.library': '暂无策略库',
    'no.stock.pool': 'No universe',
    'no.strategy': 'No strategy',

    'scan.strategy.exception': 'Abnormal scanning',
    'no.scan.to.stock': 'Scan returned no result. Modify criteria and try again',
    'request.scan.strategy.failed': 'Scan request failed',
    'scan.strategy.error': 'Strategy has errors',
    'today.scan.strategy.end': 'Scan quota is used up',

    'scan.strategy.in.error': 'Please modify formula/universe before submitting scan',
    'scan.strategy.exception': 'Abnormal strategy',


    'stock.picker.exception': 'Abnormal scan',
    'no.choice.to.stock': 'No stock found. Please modify your ideas and try again',
    'connection.strategy.Service.failed': 'Connecting to service...',
    'request.stock.picker.failed': 'Scan request failed',
    'stock.picker.strategy.error': 'Strategy has errors',
    'reaching.strategy.quota': 'No strategy quota',
    'today.stock.picks.end': 'Daily scan quota is used up',

    'filter.Reached.upper.limit': 'The running filter has reached its upper limit',

    'remaining.times': 'Daily quota remaining',//'Today\'s remaining quota',
    'times': '',

    'Intelligent.analysis.failed': 'Analysis failed',
    'unable.get.intelligent.analysis.results': 'Got no analysis result',
    'connection.analytics.service.failed': 'Failed to connect to the analysis service',
    'request.analytics.failed': 'Request failed',
    'request.analysis.timeout': 'Request timed out',

    'save.strategy.success': 'Save strategy successfully',
    'to view, please go': 'To view, please go to',
    'my.strategy': 'My scans',
    'save.strategy.exception': 'Abnormal saving strategy',
    'save.strategy.failed': 'Failed to save strategy',
    'save.strategy.account.not.exist': 'Account for saving strategy does not exist',
    'request.save.strategy.failed': 'Failed to request saving strategy',
    'save.strategy.timeout': 'Saving strategy timed out',
    'save.strategy.error': 'Saving strategy encountered errors',

    're-get.stock.condition.failed': 'Failed to retrieve scan conditions',

    'already.add.success': '{num} stock(s) added successfully',
    'stocks': 'stocks',

    'view.my.self-selected.stock': 'View my stocks',
    'self-selected.stock.added.success': 'Stock added successfully',
    'joining.stock.pool.failed': 'Failed to add the universe',

    'save.strategy': 'Save formula',
    'edit.strategy': 'Edit scan',
    'new.strategy': 'New scan',
    'copy.strategy': 'Copy scan',
    '_copy': '_Copy',

    'strategy.name.already.exists': 'Strategy name already exists. Try another name.',

    'new.strategy.success': 'Strategy is now created',
    'copy.strategy.success': 'Strategy is copied',

    'saved.strategy.in.error': 'Please modify the formula or universe before saving',
    'stock.picker.strategy.in.error': 'Please modify the formula or universe before scanning stocks',
    'strategy.content.length.too.long': 'Content length cannot exceed 8000 bytes',

    'example': '，Examples：',

    'prompt': 'Prompt',
    'are.you.leaving.this.page': 'Leave this page now? Your changes will not be saved',
    'leave': 'Leave',
    'stay': 'Stay',
    'clear': 'Clear',

    //'use.formula.generated.or.vernacular.stock.selection': 'Use generated formula from above, or script your own recipe formula.',
    'use.formula.generated.or.vernacular.stock.selection': 'Copy and paste the formula generated by GPT, or modify to your requirement.',

    'strategy.name.format': 'Chinese, letter case, numbers only',

    'real-time.market.stock.picker': '',//According to the above stock scanning strategy, use real-time market data to pick stocks.

    'saving': 'Saving...',

    'strategy.name.form': 'Name：',
    'strategy.name.placeholder': 'Give a good name (1-24 bytes)', //tod

    'vernacular.stock.picking': 'Ideas',
    'guess.you.want.input': 'Guess what you want',
    'change.batch': 'More',
    'input.stock.picking.statement': 'Describe stock pattern (Highlighted quantity in corresponding formula can be changed to your preferrance)',
    'input.hawkeye.statement': 'Describe stock pattern (Highlighted quantity in corresponding formula can be changed to your preferrance)',
    'parsing': 'Analyzing...',
    'intelligent.analysis': 'Understand',

    'correspond.formula': 'Generated quancept formula',
    'using.formula': 'Add to scan',
    'formula.editing': 'Edit formula',

    'stock.picking': 'Scanning...',
    'real.stock.picking': 'Go',

    'press': 'By',
    'sort.filter': 'Sort',
    'sort,filter': '，show',
    'before': 'Top',
    'after': 'Bottom',
    'ranking': '20',

    'latest': 'Last',
    'latest.price': 'Price',
    'quote.change': 'Change',
    'volume': 'Volume',
    'turnover': 'Turnover',
    'turnover.rate': 'Turnover Rate',
    'volatility': 'Volatility',

    'strategy.formula': 'Formula',
    'comment': 'Note',

    'stock.pool.name.already.exists': 'The universe name already exists',
    'stock.pool.name.format': 'Letters and numbers only',
    'please.select.or.new.stock.pool': 'Select or create a new universe ',

    'select.all': 'All',

    'symbol.code': 'Symbol',
    'symbol.name': 'Name',
    'symbol.type': 'Type',

    'eligible.stocks': '{num} {name}(s) met your ideas',

    'new.stock.pool': 'New universe',
    'add.choice': 'Add to universe',
    'save.stock': 'Export',
    'stock.pool.name.form': 'Name：',
    'stock.pool.name.placeholder': 'Universe name (1-20 bytes)',

    'mete.price': 'Price/Volume',
    'fundamental': 'Fundamental',
    'technically': 'Technical',
    'other': 'Others',

    'vernacular.left.prompt': 'Select from ideas in left panel, or type key word, e.g. "Bollinger band", or type your complete idea, e.g. "Price makes 50 day high", and click "Understand"',
    'not.match.mete.price.statements': 'No price and volume sentences matched',
    'not.match.fundamental.statements': 'No fundamental sentences matched',
    'not.match.technically.sentences': 'No technical sentences matched',
    'not.match.other.statements': 'No other sentences matched',
    'not.match.intraday.statements': 'No intraday sentences matched',

    'index.component': 'Index components',
    'all.stocks': 'All',

    'ST.stock': 'ST stocks',
    'contain': 'Include ST',
    'excluded': 'No ST',

    'optional.stock.pool': 'My universe',
    'stock.pool': 'Universe',
    
    'total.stock': 'Stocks',

    'stock.pool.count': 'Total number of stocks: {num}',
    'index.pool.count': 'Total number of indices: {num}',
    'fund.pool.count': 'Total number of ETFs: {num}',

    'stock': 'Stock',
    'fund': 'ETF',
    'index': 'Index',
    'general.index': 'HS Index',

    'please.select.stock.pool': 'Please select universe',

    'sh.sz.motherboard': 'HS Motherboard',
    'second.boardmarket': 'GEM',
    'sme.board': 'SME',
    'csi.300': 'HS300',
    'csi.500': 'ZZ500',
    'csi.800': 'ZZ800',

    'area.plate': 'Area Plate',
    'concept.plate': 'Concept Plate',
    'industry.plate': 'Industry Plate',
    'src.plate': 'SFC Industry',
    'index.plate': 'Index Plate',
    'other.plate': 'Other Plate',

    'sys.fund.pool': '系统基金池',
    'sh.grading.mother': '沪分级母',
    'sh.grading.a': '沪分级A',
    'sh.grading.b': '沪分级B',
    'sz.grading.mother': '深分级母',
    'sz.grading.a': '深分级A',
    'sz.grading.b': '深分级B',

    'nyse': 'NYSE',
    'nasdaq': 'Nasdaq',
    'd-jones.index': 'DOW 30',
    'nasdaq.100': 'NASDAQ 100',
    'sp.500': 'S&P 500',
    'russell.2000': 'Russell 2000',

    'my.strategy.lib': 'My scans',
    'new.strategy.lib.stock.picker': '新建策略库选股',
    'new.vernacular.stock.picker': 'New scan',

    'rename': 'Rename',
    'copy': 'Copy',
    'remove': 'Delete',

    'update': 'Update',

    'backtest.status': 'Backtest status',
    'last.updated': 'Last updated',
    'backtest.count': 'Backtest count',
    'control': '',
    'backtest.items': 'Backtest list',

    'remove.this.strategy': 'Are you sure you want to delete this strategy?',
    'yes': 'Yes',
    'no': 'No',

    'rename.strategy.failed': 'Rename failed',
    'copy.strategy.failed': 'Copy failed',
    'copy.strategy.account.not.exist': 'Account does not exist',
    'request.copy.strategy.failed': 'Request failed',
    'copy.strategy.timeout': 'Replication timeout',
    'copy.strategy.error': 'The replication strategy has errors',
    'connection.strategy.server.failed': 'Failed to connect to the strategy server',

    'want.delete.stock': 'Are you sure you want to delete the stock?',
    'remove.strategy.success': 'Deleted successfully',
    'remove.strategy.failed': 'Delete failed',

    'add.stock.option': 'Add stock',
    'add.stock.option.failed': 'Add failed',
    'reach.the.stock.quota': 'Reached stock quota',
    'add.or.update.stock.option.failed': 'Failed to add or update stock',
    'remove.stock.option.success': 'Deleted successfully',
    'remove.stock.option.failed': 'Delete failed',

    'copy.stock.pool': 'Copy universe',
    'make.sure.delete.stock.pool': 'Are you sure you want to delete the universe?',

    'no.matches.found': 'No matches found',
    'No strategy available': 'No strategy available',

    'update.failed': 'Update failed',
    'update.success': 'Update successfully',
    'logout.failed': 'Logout failed',

    'edit.user.info': 'Edit user information',

    'my.home': 'My home',
    'value-added.services': 'Recharge',
    'my.account': 'My bill',
    'account.setting': 'Account setting',
    'message': 'Message',
    'exit': 'Exit',

    'coupon': 'Coupon',
    'be.usable': 'Be usable',
    'no.coupon.available': 'You have no coupons available',
    'valid.until': 'Valid until',
    'invalid.coupon': 'Invalid coupon',
    'no.invalid.coupon': 'You have no invalid coupons',
    'to.use': 'Go to use',

    'send': 'Send',
    'get.message.failed': 'Failed to get message',
    'send.message.success': 'Send message successfully',
    'send.message.failed': 'Send message failed',
    'private.letter.administrator': 'Send message to the administrator',
    'personal message': 'Personal message',
    'sys.message': 'System information',

    'all': 'All',
    'complete': 'Complete',
    'processing': 'Processing',
    'failure': 'Failed',

    '1month': '1 month',
    '6month': '6 months',
    '1year': '1 year',

    'tradeTime': ' Trade time',
    'tradeAmount': 'Trade amount',
    'tradeIntro': 'Trade details',
    'months': 'Months',
    'expiredDate': 'Expired date',
    'tradeStatus': 'Trade status',

    'get.account.info.failed': 'Obtain account information failed',

    'time': 'Time',
    'recent': 'Recent',
    'status': 'Status',
    'tradeRecord': 'Trade record',

    'real.stock.picker': 'Stock scanning',
    'stock monitoringr': 'Stock monitoring',

    'personal.position.scan': '个人仓位扫描',
    'parameter.settings': '参数设置',
    'option.scan.exception': '期权扫描出现异常',
    'option.scans.have.run.out': '本月期权扫描次数已用完',
    'request.option.scan.failed': '请求期权扫描失败',
    'no.option.data.scanned': '没有扫描到期权数据',

    'profitloss': '损益',
    'price': 'Price',
    'profit.and.loss': '到期收益',

    'optionStrategyScan': '期权策略扫描',
    'factorScan': '因子扫描',
    'factorGeneration': '量化因子服务因子生成',
    'intelligentFactorAnalysis': '智能因子分析',
    'ordinary.member': 'General member',
    'vip.member': 'VIP',
    'intro': 'Introduction',
    'intro.description': 'This guy is lazy and leaves nothing~',
    'account': 'Account',
    'value-added.service.usage.status': 'Value-added service usage status',
    'coupons': 'coupons',

    'used': 'Used',
    'expired': 'Expired',

    'can.only.upload.image.files': 'jpg. only',
    'upload.avatar.size': 'Must be less than 2MB',

    'account.name.already.exists': 'The account name already exists',
    'update.password.success': 'Password has been updated',
    'update.password.failed': 'Password change failed',
    'old.password.input.error': 'The original password is incorrect',
    'newPassword.and.oldPassword.not.same': 'The new password and the original cannot be the same',
    'newPassword.and.confirmPassword.must.same': 'New password and the confirmation must match',

    'phone.is.bound': 'Mobile number is bound',
    'binding.success': 'Bind successfully',
    'unbind.success': 'Unbind successfully',
    'binding.failed': 'Binding failed',
    'unbind.failed': 'Unbind failed',
    'account.is.bound.phone': 'The mobile number is already registered',
    'verification.code.error': 'Verification code error',
    'nickname.format': 'Chinese, letter case, number only',
    'upload.failed': 'Upload failed',

    'ok.to.unbind': 'Are you sure you want to unbind the mobile number?',

    'basic.info': 'Basic information ',
    'nickname': 'User\'s nickname',
    'bind.phone': 'Bind mobile number ',

    'unbind': 'Unbind',

    'please.input.bind.phone': 'Mobile number to bind',

    'login.password': 'Login password',
    'update.password': 'Change password',
    'old.password': 'Old password',
    'new.password': 'New password',
    'confirm.password': 'Confirm password',

    'personal.profile': 'Introduction',
    'modify.avatar': 'Change your picture',
    'select.avatar': 'Select a picture',

    'upload.image.format': 'JPG, JPEG, BMP or PNG format pictures are suitable, no more than 2MB. Drag or zoom the dotted squares in the picture to adjust the avatar.',

    'payment.server.00.01': 'Upon registration, you have',
    'payment.server.00.02': 'First 7 days:20 scans/day,3 monitors/day',
    'payment.server.00.03': 'After 7 days:3 scans/day,3 monitors/day',

    'payment.server.01.01': '10 scans/day,10 monitors/day',
    'payment.server.01.02': '',

    'payment.server.02.01': 'Add 30 scans/day',
    'payment.server.03.01': 'Add 50 scans/day',

    'payment.server.04.01': '1. 基于对市场未来预期，对不同时间跨度、涨跌幅的期待，进行期权策略扫描，获取不同期权策略组合的结构、收益、风险及图示；',
    'payment.server.04.02': '2. 可享受总共30次/月期权策略扫描服务；',

    'payment.server.05.01': '1. 金融大数据结合人工智能技术，技术指标、财务数据、实时量价等因子库信息实时生成因子；',
    'payment.server.05.02': '2. 可享受30次/天因子扫描服务；',
    'payment.server.05.03': '3. 可享受5次/天因子生成服务；',
    'payment.server.05.04': '4. 可享受5次/天智能因子分析服务；',

    'inSync.platform': 'InSync-Quancept Quantization Platform',
    'payment.server.06.01': 'Scan, filter the market any way you like',
    'payment.server.06.02': 'Build strategies with great detail, in English',
    'payment.server.06.03': 'Backtest and optimize',
    'payment.server.06.04': 'Trade and manage all your strategies and positions',
    'payment.server.06.05': 'Profit target, stop loss and time - based exit',
    'payment.server.06.06': 'Conditional orders triggered by your custom rules',

    'hawkeye.server.07.01': 'Add 30 monitors/day',

    'factor.scan': '因子扫描',
    'factor.generation': '因子生成',
    'intelligent.factor.analysis': '智能因子分析',

    'option.strategy.scan': '期权策略扫描',

    'payment.failed': 'Failed to pay',

    'option.strategy.service': '期权策略服务',
    'Quantitative factor service': '量化因子服务',

    'upgrade.vip.member': 'To be VIP',
    'free': 'Free',
    'buy': 'Buy',
    'pay': 'Pay',
    'yuan': '',
    'usd': '$',
    'wan': ' Ten thousand',
    'yuan/month': '/month',

    'yuan/year': '/year',
    'yuan/2year': '/2 years',
    'discount': 'Discount',

    'remaining.validity.period': 'Time remaning',

    '1year.discount': '1 year (24% discount)',
    '2year.discount': '2 years (25% discount)',

    'vip.special': 'VIP',

    'service.name': 'WebTrader',
    'unit.price': ' unit price ',
    'vip.special.price': 'VIP special price',
    'subtotal': ' Total ',
    'do.not.use': 'Do not use',
    'no.available': 'Not available',

    'Scan': 'Scan',
    'Monitor': 'Monitor',
    'Explores': 'Explores',

    'payment.prompt.01': 'Please pay as soon as possible, do not close this window before completing ',
    'payment.prompt.02': ' Any payment problems, contact',

    'service.intro': 'Description',
    'Expiration': 'Expiration',
    'RemainingCredit': 'Remaining Credit',
    'please.select.service.type': 'Services',
    'waiting.for.payment': 'Waiting for payment',
    'confirm.payment': 'Confirm payment',
    'description': 'Description',

    'payment.info.03': 'Scan and monitor stock market, using natural language. Automate trading strategy, with no code.',
    'payment.info.01': 'Purchase is not refundable',
    'payment.info.02': 'Issues related to trade or account recharge should be reported to support@quancept.com',

    'quancept.info.qq': 'QQ：487139452',
    'quancept.info.phone': 'Phone：021-52685165',
    'quancept.info.work': ' Monday to Friday 09:00—19:00',


    'download.immediately': 'Download',
    'download.info.001': 'Strategy platform',
    'download.info.002': 'scan/filter the market',
    'download.info.003': 'build strategies in plain english',
    'download.info.004': 'portfolio - backtest and optimize',
    'download.info.005': 'trade strategy live/simulation',

    'download.info.006': 'Execution mamangment',
    'download.info.007': 'complex-condition order',
    'download.info.008': 'trading algos',
    'download.info.009': 'full-lifecycle trading',
    'download.info.010': 'multi-strategy trading',
    'download.info.011': 'multi-account trading',
    'download.info.012': 'fully-automated/manual confirm',

    'android.version': 'Android version',
    'ios.version': 'IOS version',

    'stay.tuned': 'Stay tuned',
    'download.info.08': 'Stock robot',
    'download.info.09': ' Based on Quancept\'s rich accumulation of quantitative systems and transactions for many years, combining AI and machine learning technology, through interaction, to achieve a series of intelligent quantitative investment services such as stock scan, backtesting, strategy optimization, and ordering',

    //因子扫描
    'factor.scan.result': '根据最新行情数据，共扫描出 {num} 只{name}',
    'save.factor.local': '查看全部数据，请保存至本地',
    'my.factor.file': '我的因子文件',
    'factor.title.01': '1、因子扫描',
    'scanning': 'Scanning...',
    'generating.factor.file.condition': '根据以上公式条件，生成因子文件',
    'factor.title.02': '2、生成因子文件',

    'generating.factor.file': '生成因子文件',
    'generating': '正在生成',
    'submitting': 'Submitting...',
    'ready.generate': '准备生成',
    'build.failed': '生成失败',
    'factor.generation.has.run.out': '今日因子生成次数已用完',
    'data.frequency': '数据频率',
    '60minute.line': '60分钟线',
    'generated.complete': '生成完成',
    'please.complete.factor.scan': '请完成因子扫描',

    'start.generating': '开始生成',
    'generated.file.in': '生成文件中',
    'not.analyzed': '未分析',
    'start.analysis': '开始分析',
    'analysis.failure': '分析失败',
    'analyzing': '分析中',
    'analysis.completed': '分析完成',
    'upload.factor.format': '你只能上传csv文件',
    'upload.factor.size': '上传文件必须小于20MB',
    'factor.file.name': '因子文件名',
    'last.update.date': '最后更新日期',
    'type': 'Type',
    'is.submitting': 'Submitting ',
    'prepare.analysis': '准备分析',
    'view.analysis.results': '查看分析结果',
    'build.please.wait': '生成中，请稍后',

    'upload': 'Upload',
    'generate': 'Generate',

    'analysis.of.anomalies': '分析出现异常',
    'error.analyzing.data': '分析数据出错或不存在',
    'analysis.points.end': '今日分析点数已用完',
    'analysis.server.not.responding': '分析服务器无响应',
    'no.querying.analysis.tasks': '没有查询到分析的任务',

    'upload.failed': 'Upload failed',

    'remove.factor.file.failed': '删除因子文件失败',

    'analyze.this.factor.file': '你确定要分析这个因子文件吗?',
    'analysis': '分析',
    'cancel': 'Cancel',

    'delete.this.factor.file': '你确定要删除这个因子文件吗?',

    'upload.factor.file': '上传因子文件',

    'factorName': '因子名称',
    'periodWise': '周期',
    'totalRet': 'Return',
    'sharpeRatio': '夏普-[Sharpe]',
    'annAlpha': '阿尔法-[ALPHA]',
    'beta': '贝塔-[BETA]',

    'have': 'Yes',
    'not': 'No',

    'industry.name': 'Industry',
    'monotonic(period)': '单调性(周期)',
    'monotonic': '单调性',

    'factor.analysis': '因子分析',

    'rate.of.return.analysis': '收益率分析',
    'ic.analysis': 'IC分析',
    'turnover.analysis': '换手率分析',

    //期权
    'breakEvenPoint': '盈亏平衡点',
    'Long Call': '买入看涨',
    'Uncovered Put Write': '无备兑看跌',
    'Bull Call Spread': '牛市看涨价差',
    'Bull Put Spread': '牛市看跌价差',
    'Bull Call': '牛市看涨',
    'Bull Put': '牛市看跌',
    'Synthetic Long Stock': '合成股票多头',
    'Synthetic Long Stock 2': '合成股票多头2',
    'Call Backspread': '看涨反向价差',
    'Covered Calls': '抛补看涨',
    'Synthetic Long Call': '合成买入看涨',
    'Collar': '领子',
    'Covered Combination': '备兑组合',
    'Covered Straddle': '备兑跨式',

    'Long Put': '买入看跌',
    'Naked Call': '裸卖空',
    'Naked Call 2': '裸卖空2',
    'Bear Call': '熊市看涨',
    'Bear Put': '熊市看跌',
    'Put Backspread': '看跌反向价差',
    'Synthetic Short Stock': '合成股票空头',
    'Synthetic Short Stock 2': '合成股票空头2',
    'Covered Put Write': '备兑看跌',
    'Synthetic Long Put': '合成买入看跌',

    'Call Ratio Spread': '看涨比率价差',
    'Put Ratio Spread': '看跌比率价差',
    'Long Straddle': '买入跨式',
    'Short Straddle': '卖出跨式',
    'Long Strangle': '买入宽跨式',
    'Short Strangle': '卖出宽跨式',
    'Long Guts': '买入飞碟式',
    'Short Guts': '卖出飞碟式',
    'Strip': '条式',
    'Strap': '带式',
    'Ratio Call Write': '比率看涨',
    'Ratio Put Write': '比率看跌',
    'Long Put Synt Straddle': '买入看跌合成跨式',
    'Long Call Synt Straddle': '买入看涨合成跨式',
    'Long Put Butterfly': '买入看跌蝶式',
    'Short Put Butterfly': '卖出看跌蝶式',
    'Long Butterfly': '买入蝶式',
    'Short Butterfly': '卖出蝶式',
    'Long Call Ladder': '买入看涨梯形',
    'Short Call Ladder': '卖出看涨梯形',
    'Long Put Ladder': '买入看跌梯形',
    'Short Put Ladder': '卖出看跌梯形',
    'Variable Ratio Write': '可变比率',
    'Condor': '秃鹰',
    'Short Condor': '卖出秃鹰',
    'Iron Condor': '铁秃鹰',
    'Reverse Iron Condor': '反向铁秃鹰',
    'Iron Butterfly': '铁蝶式',
    'Reverse Iron Butterfly': '反向铁蝶式',

    'Reversal': '反转',
    'Conversion': '转换',
    'Long Box': '买入箱体',
    'Short Box': '卖出箱体',

    'Neutral Calendar': '中性日历',

    'Short Calendar Straddle': '卖出日历宽跨式',

    'Fake Neutral Calendar': '伪装中性日历',

    'PriceRiseTo': 'Price Rises To',
    'PriceRiseToInfo': 'Price rises to ${num}',

    'PriceFellTo': 'Price Drops To',
    'PriceFellToInfo': 'Price drops to ${num} ',

    'ReboundRange': 'Retrace',
    'ReboundRangeInfo': 'Price rises to ${num1}，then retrace ${num2}',

    'Fallback': 'Rebound',
    'FallbackInfo': 'Price drops to ${num1}，then rebound ${num2}',

    'priceDownTo': 'Price drops to',
    'priceUpTo': 'Price rises to',
    'Bounce': 'Rebound',
    'huiLuo': 'Retrace',

    'UpperOvergo': 'Cross above',
    'UnderOvergo': 'Cross below',
    'AvgLine': 'moving average',

    'VolumeIsPast': 'Volumn is ',
    'Average': 'Average',
    'day': 'Day',
    'multiple': 'Times',

    'DailyIncreaseReached': 'Today price up to ',
    'DailyIncreaseReachedInfo': 'Today price up {num}%',

    'DailyDeclineReached': 'Today price down to ',
    'DailyDeclineReachedInfo': 'Today price down {num}%',

    'dayIncreaseReach': 'Today up',
    'dayDeclineReach': 'Today down',

    'PriceRise': 'New High',
    'PriceFalling': 'New Low',
    'priceUpWound': 'Price makes high of ',
    'priceUpWoundHistoryHigh': 'Price makes historic high',
    'priceUpWoundInfo': 'Price at {num} day high ',

    'priceDownWound': 'Price makes low of ',
    'priceDownWoundHistoryLow': 'Price makes historic low ',
    'priceDownWoundInfo': 'Price at {num} day low',

    'StockPriceWearOn': 'Price crosses above moving average',
    'StockPriceWearOnInfo': ' Price crosses above {num} {avg} moving average',

    'StockPriceFellBelow': ' Price crosses above moving average',
    'StockPriceFellBelowInfo': 'Price crosses below {num} {avg} moving average',

    'StockPriceUp': 'Cross Above',
    'StockPriceDown': 'Cross Below',

    'Increase': 'Increase',
    'IncreaseInfo': 'within {num1} minute，the increase reaches {num2}%',

    'Decline': 'Decline',
    'DeclineInfo': 'within {num1} minute，the decline reaches {num2}%',

    'increaseReach': 'The increase reaches',
    'declineReach': 'The decline reaches',

    'DailyTurnoverRate': 'Daily Turnover',

    'KDJGoldFork': 'KDJ Gold Cross',
    'KDJDeadFork': 'KDJ Death Cross',
    'MACDGoldFork': 'MACD Gold Cross ',
    'MACDDeadFork': 'MACD Death Cross',

    'PricesGoThroughBollinger': 'Price Cross Above Bollinger Upper',
    'PricesGoThroughBollingerInfo': '{num1} Price cross above{num2}',

    'PriceDownBollinger': ' Price Cross Below Bollinger Lower',
    'PriceDownBollingerInfo': '{num1} Price cross below {num2}',

    'BuyOneHigherThan': 'Bid price above',
    'SellPriceBelow': 'Ask price below',
    'ReachHigh': 'Open high at',
    'GapReachHigh': 'Gap high to',

    'VolumeAveragePastDays': 'Volume is past {num1} day average’s {num2} times',
    'VolumeRatio': 'Volume Ratio',
    'VolumeRatioThan': 'Volume Ratio greater than',
    'DailyAmplitude': 'Daily volatility',

    'AnyOnlineWear': 'Any moving average up cross',
    'AnyOnlineWearInfo': '{num1} {avg1} moving average up cross {num2} {avg2} moving average',
    'AnyMovingAverage': 'Any moving average down cross',
    'AnyMovingAverageInfo': '{num1} {avg1} moving average down cross {num2} {avg2} moving average',

    'intelligentHawkeye': 'Alert only',
    'newHawkeye': 'New monitor',
    'myHawkeye': 'My monitors',
    'Monitor symbol': 'Monitor symbol of choice for price/volume and technical events. Formulate ideas using AI-powered language assistant.',

    'closeShort': 'Buy',
    'closeLong': 'Sell',

    'closeShortHawkeye': 'Buy Monitor',
    'closeLongHawkeye': 'Sell Monitor',

    'smartPay': 'Direct Order',
    'goHawkeye': 'Go',
    'PaySingle': 'Go',

    'intelligentHawkeyeConfirm': 'Confirm monitor',
    'today.hawkeye.end': 'Today’s quota is exhausted.',

    'settingSuccess': 'Success',
    'stopHawkeyeMsgSendSuccess': ' The message to stop the monitor was sent successfully ',

    'isConfirmPlaceOrder': 'Confirm order?',

    'confirm': 'confirm',
    'submitPlaceOrder': 'Submit order',
    'cancelPlaceOrder': 'Cancel order',
    'sendSucc': '{cont} sent successfully',
    'sendFail': '{cont} send failure',
    'hawkeyeCondFail': 'Monitoring condition error(s)：{cont}',

    'intelligentHawkeyeAlert': 'IntelliMon alert',
    'HawkeyeAlertRemind': ' {cont} monitoring conditions triggered. View detail？',

    'close': 'Close',
    'view': 'View',
    'stop': 'Stop',
    'placeOrder': 'Place order',

    'pendingOrder': 'Order pending',
    'monitoring': 'Monitoring',
    'over': 'Completed',

    'hawkeyeMode': 'Notification',

    'ClosePendingOrder': 'Close pending order(s)',
    'PendingOrderHawkeye': 'Orders to submit',

    'symbolName': 'Name',
    'symbolCode': 'Symbol',
    'hawkeyeType': 'Monitoring type',
    'hawkeyeCondition': 'Add condition',
    'tradeDirection': 'Direction',
    'tradeQuantity': 'Quantity',
    'expireDate': 'Expire time',    //??labeled as date but Chinese shows time???
    'triggerDate' : 'Trigger time',
    'triggerCondition': 'Trigger condition',

    'hawkeyeStragegy': 'Ideas',

    'vernacularHawkeye': 'Idea',
    'priceHawkeye': 'Price',
    'condHawkeye': 'Condition',
    'kLineHawkeye': 'Chart',
    'HybridHawkeye': 'Mixed',

    'hawkeyeAction': 'Direction',
    'effectTime': 'Effective from ',

    'reach': 'To',
    'norm': 'Indicator',
    'value': 'Value',

    'delete': 'Delete',
    'Add to conditions': 'Add to conditions',
    'hCondition': 'Condition',

    'numMinLine': '{num} minute interval',
    '1MinLine': '1 minute interval',
    '2MinLine': '2 minute interval ',
    '3MinLine': '3 minute interval',
    '5MinLine': '5 minute interval',
    '10MinLine': '10 minute interval',
    '15MinLine': '15 minute interval',
    '20MinLine': '20 minute interval',
    '30MinLine': '30 minute interval',
    '60MinLine': '60 minute interval',
    'dailyLine': 'Daily interval',

    '5DayHigh': '5-day high',
    '10DayHigh': '10-day high',
    '20DayHigh': '20-day high',
    '30DayHigh': '30-day high',
    '60DayHigh': '60-day high',
    '120DayHigh': '120-day high',
    '200DayHigh': '200-day high',
    'historyHigh': 'Historic high',

    '5DayLow': '5-day low',
    '10DayLow': '10-day low',
    '20DayLow': '20-day low',
    '30DayLow': '30-day low',
    '60DayLow': '60-day low ',
    '120DayLow': '120-day low',
    '200DayLow': '200-day low ',
    'historyLow': 'Historic low',

    '5DayAvgLine': '5-day moving average',
    '10DayAvgLine': '10-day moving average',
    '20DayAvgLine': '20-day moving average',
    '60DayAvgLine': '60-day moving average',
    '120DayAvgLine': '120-day moving average ',
    '200DayAvgLine': '200-day moving average ',

    '1MinInside': 'Within 1 minutes ',
    '2MinInside': 'Within 2 minutes ',
    '3MinInside': 'Within 3 minutes ',
    '5MinInside': 'Within 5 minutes ', 
    '10MinInside': 'Within 10 minutes ',
    '15MinInside': 'Within 15 minutes ',
    '30MinInside': 'Within 30 minutes ',
    '60MinInside': ' Within 60 minutes ',

    'bollingerOnRail': ' Bollinger Upper Band',
    'bollingerLowRail': ' Bollinger Lower Band ',

    'OnRail': 'Upper band',
    'LowRail': 'Lower band',

    'priceUp': 'Cross above',
    'priceDown': 'Cross below',

    'ordered': ' Order placed ',
    'triggered': ' Triggered ',
    'closed': 'Closed',
    'activeTermination': 'Active Termination',
    'hawkeyeError': 'Monitoring error',
    'invalid': 'Expired',

    'PleaseEnterQuoteChange': 'Please enter price up/down range',
    'priceNotEmpty': 'Please enter Price',
    'priceDiffNotEmpty': ' Please enter Price Difference',

    'PleaseEnterTargetPrice': 'Please enter Target Price',
    'PleaseEnterIncrease': 'Please enter Up Range',
    'PleaseEnterDecline': ' Please enter Down Range ',
    'PleaseEnterTargetExtent': 'Please enter Target Extend',
    'PleaseEnterDays': 'Please enter number of days',
    'PleaseEnterMultiple': 'Please enter Multiplier',
    'PleaseEnterVolumeRatio': 'Please enter Volume Ratio',
    'PleaseEnterTargetAmplitude': 'Please enter Target Amplitude',
    'PleaseEnterInteger': ' Please enter a whole number',

    'pleaseEnterRange0-100': 'Enter a number between 0 and 100',
    'pleaseEnterTargetTurnoverRate': 'Enter your target turnover rate',

    'selCondTrigger': 'Monitor Detail (Monitor completes upon triggering of any condition)',
    'hawkeye.info': 'You have started {priceCount} price monitor(s)，{condCount} 个condition monitor(s)，{mixCount} mixed monitor(s)。',
    'hawkeye.mode': '',//根据以上策略，使用实时行情智能盯盘，触发条件后
    //Based on the above strategy using real-time market date ?

    'confirmOrderManually': ' Place order manually',
    'systemAutoOrders': ' Place order automatically',

    'startDateGreaterThanEndDate': 'Start date must be before End Date',
    'tradeQuantityFormatFail': 'Trade Quanity format error',
    'tradeQuantityLengthFail': 'Trade Quantity cannot be more than 12 digits long',
    'tradeQuantityNotEmpty': 'Please enter Trade Quantity',
    'pleaseEnterStockName-Symbol': 'Please enter stock name/ticker',
    'pleaseEnterStartDate': 'Please enter Start Date',
    'pleaseEnterEndDate': 'Please enter End Date',
    'customExpirationTime': 'Custom Expiration', 
    'VIP.use-value.added.services': '(VIP only)',
    'hawkeyeUpperLimit': 'You can choose at most 5 ideas', 

    'deleteHawkeyeFailed': 'Failed to delete monitor ',
    'confirmPlaceOrder': 'Confirm order for “{name}”？',
    'confirmPlaceOrders': 'Confirm {num} orders for “{name}”?',

    'confirmCloseHawkeye': 'Close monitor “{name}” with pending order(s)？',
    'confirmCloseHawkeyes': 'Close “{name}” {num} monitor(s) pending order？',

    'confirmStopHawkeye': 'Terminate monitor “{name}”？',
    'confirmStopHawkeyes': 'Terminate “{name}”  {num} running monitor(s)？',

    'confirmRemoveHawkeye': 'Delete completed Monitor “{name}”？',
    'confirmRemoveHawkeyes': 'Delete “{name}” {num} completed monitor(s)？',

    'selProduct': 'Please select a product',

    'videoTitle01': ' Stock Selection Filter',
    'videoCont0101': '1. Login and create a new stock filter-1',
    'videoCont0102': '2. Login and create a new stock filter-2',
    'videoCont0103': '3. Login and create a new stock filter-3',
    'videoCont0104': '4. Add stock selection criteria',
    'videoCont0105': '5. Use self-defined code for stock selection',

    'videoTitle02': 'Create a complete strategy',
    'videoCont0201': '1. How to create a complete strategy',
    'videoCont0202': '2. How to use strategy editor',
    'videoCont0203': '3. Create a strategy and back test',

    'videoTitle03': 'DIY Strategy Zone',
    'videoCont0301': '1.Fundamental',
    'videoCont0302': '2. Bollinger Band',
    'videoCont0303': '3. Use Phased High/Low Ticks',  
    'videoCont0304': '4. Implement Commodity Strategy ',
    'videoCont0305': '5. Establish a buy/sell filter',
    'videoCont0306': '6.  How to preset variables in the formula filter',

    'videoTitle04': 'Trading Functionalities',
    'videoCont0401': '1. CrystalTrade Functionality Intro',
    'videoCont0402': '2. Manual Trade',

    'protocol': 'Membership Agreement',

    'commissionInformation': 'Please confirm the following commission information：',
    'orderConfirmation': 'Order Confirmation',
    'commissionMode': 'Commission Mode',
    'marketPrice': 'Market Price',

    'applicationSubmitted': 'Your request has been submitted',

    'orderInfo': 'Order Information',

    'margin': 'Margin',

    'hawkeyeConditionAlreadyExists': 'Criterion exists already',

    'intraday': 'Intraday',
    'Sector': 'Sector',

    /*回测*/
    'stockBacktest': 'Backtest',
    'myBacktest': 'My backtest',

    'strategyExcavate': 'Explore',
    'AIincrease': 'Incremental Return',
    'combination-strategyExcavate': '组合策略挖掘',
    'rollingBacktest': '滚动回测',

    'optimalGrid': '最佳网格数',
    'optimizationGrid': '4D optimization',
    'myTrade': 'My trading',
    'mySimulated': 'My trade simulate',
    'myRealTime': 'My trade live',

    'myExcavate': 'My exploration',

    'strategyLib': 'Strategy library',
    'backtestCondition': 'Backtest conditions',

    'created': 'Submit time',
    'maxRateOfReturn': 'Maximum annualized return',
    'maxdrawdown': 'Max drawdown',
    'strategyPeriod': 'Strategy period',
    'backtestInterval': 'Period',
    'strategyNumber': 'Strategy count',

    'dayTradeOnly': 'Holding period',

    'crossDay': 'Overnight',

    'digging': 'Exploring...',
    'backtesting': 'Backtesting',
    'optimizing': 'Optimizing',

    'importBacktestResult': 'Export backtest results',

    'backtestFilter': 'Criteria',
    'clearFilter': 'Clear',

    'backtestTime': 'Backtest time',

    'annualizedRateOfReturn': 'Annual return',

    'search': 'Filter',
    'symbolName&Code': 'Security name/symbol',

    'theAbove': 'Above {num}',
    'theFollowing': 'Below {num}',

    'startBacktest': 'Start backtest',
    'backtestStatus': 'Backtest status',

    'backtestingConsuming': 'Backtesting，Time-consuming {num}s',
    'backtestCompletedConsuming': 'Completed in {num} seconds',

    'bullishStrategy': '看涨策略',
    'bearishStrategy': '看跌策略',
    'shockStrategy': '震荡策略',

    'todayBacktestNumberRunOut': 'The number of backtests today has been used up',
    'todayBatchBacktestNumberRunOut': 'Today\'s multi - dimensional optimization quota has been used up',

    'newRealTimeTrade': 'Trade live',
    'newSimulationTrade': 'Simulate trading in live market',

    'goRealTime': 'Trade live',
    'goSimulation': 'Simulate live',

    'tradingStraregy': 'Trading strategy',
    'strategyType': 'Strategy type',
    'startTime': 'Start time',
    'endTime': 'End time',

    'minimumCapital': 'Buying power required',

    'date': 'Date',

    'L': 'Bought',
    'S': 'Sold',

    'entryDate': 'Entry time',
    'entryPrice': 'Entry price',
    'direction': 'Direction',
    'quantity': 'Quantity',
    'exitDate': 'Exit time',
    'exitPrice': 'Exit price',
    'pnl': 'pnl',
    'initbp': 'Initial Capital',
    'exitInfo': '平仓原因',
    'remark': 'Remark',

    'excavateDetails': 'Detail',
    'backtestDetails': 'Detail',
    'fundsCurve': 'Equity curve',
    'tradeDetails': 'Trade detail',

    'incomeCurve': 'Return',
    'equityCurve': '净值曲线',

    'equity': '净值',
    'cash': '现金',

    'thisStrategy': 'This strategy',

    'totalPnl': 'Total P&L',
    'profitFactor': 'Profit ratio',
    'totalTrades': 'Total Trades',

    'CSI300': 'CSI300',
    'SP500': 'SP500',

    'number': '(Count)',

    'mostOptionalStrategies': '最多同时可选10个策略',

    'backtestRequestSucc': 'Individual stock backtest request succeeded',

    'pleaseEnterSymbolCode': 'Please enter stock name/ticker',

    'closed_on_day_close_timeout': 'Closed on market close',
    'closed_on_day_open_timeout': 'Closed on market open',
    'closed_on_EOB_timeout': 'Closed on timeout',
    'closed_on_EOD_timeout': 'Closed by end of day',
    'closed_on_request': 'Closed on request',
    'closed_on_stoploss': 'Stopped out',
    'closed_on_takeprofit': 'Reached profit target',
    'closed_on_timeout': 'Closed on timeout',
    'closed_on_trailingstoploss': 'Stopped out on trailing stop',
    'rebalance_close': 'Closed by rebalance',
    'rebalance_increase': 'Increased by rebalance',
    'rebalance_reduce': 'Reduced by rebalance',

    'stock_split_and_or_dividend': 'Split/Dividend',

    'error': 'Error',

    'want.delete.backtest': 'Sure you want to delete the backtest?',
    'want.delete.batchbacktest': 'Sure you want to delete the optimization?',
    'remove.backtest.success': 'Deleted successfully',
    'remove.batchbacktest.success': 'Deleted successfully',

    'standardStrategy': 'Standard strategy',
    'featuredStrategy': 'Featured strategy',

    'strategyNoTrade': '{name}，This strategy produced no trade.',

    'backtestGrid': 'Grid backtest',
    'backtestGrids': '智能回测',

    'gridStrategy': 'Strategy#',


    'gridSetting': 'Grid settings',
    'priceRange': 'Price range',
    'lowestPriceRange': '区间最低价',
    'highestPriceRange': '区间最高价',

    'gridCnt': 'Number of grids',
    'pleaseEnterGrids': 'Please enter the number of grids',
    'gridWidth': 'Grid width',
    'gridWidthForNum': 'Grid width {num}',
    'capital': 'Commission amount',
    'pleaseEnterAmount': '请输入金额(元)',
    'accordingToSettingsAmountMustBeGreaterOrEqualTo': '根据以上设置，金额需大于等于{num}',
    'gridCntSize': 'The number of grids must be greater than 4 and less than or equal to 20',

    'lowestPriceCannotBeGreaterThanHighestPrice': 'The lowest price cannot be greater than the highest price',

    'amountMustBeGreaterOrEqualTo': '金额需大于等于{num}',

    'priceRanges': '价格区间（元）',
    'gridWidths': '网格宽度（元）',
    'capitals': '委托金额（元）',
    'initialRateOfReturnOnCapital': '累计收益率',


    'backtestFail': 'Backtest failed',

    'discoverBestStrategy': 'Explore strategies',

    'noLoss': 'No loss',
    'noProfit': 'No profit',

    'tradeTimes': 'Trade time',
    'strikePrice': 'Trade price',
    'pnls': 'P&L',
    'profit and loss': 'P&L',

    'Size': 'Size',
    'tradeSize': 'Trade size',
    'dollars': 'Trade capital',
    'gain': 'P&L',

    'grandTotal/annualizedRateOfReturn': 'Total return/Annualized return',

    'grandTotalRateOfReturn': 'Grand total return',
    'strategyGains': 'Strategy',
    'individualStockIncome': 'Symbol',

    'individualStocks+strategyStackingIncome': 'Combined',

    'Optimized': '(Optimized)',
    'optimized details': '优化详情',

    'Cross-day trading only': 'Cross-day trading only',
    'Day trading only': 'Day trade only',

    'startOptimized': 'Start optimizing',
    'optimizing': 'Optimizing...',
    'optimizingConsuming': 'Optimizing，Time-consuming{num}s',
    'optimizedCompletedConsuming': 'Optimization is complete，Time-consuming{num}s',

    'Original income/Profit after optimization': '原收益/优化后收益',
    'Original income': '原收益',
    'Original annualized income': '原年化收益',
    'Profit after optimization': '优化后收益',
    'Annualized income after optimization': '优化后年化收益',
    'Original profit-loss ratio': '原盈亏比',
    'Profit and loss ratio after optimization': '优化后盈亏比',

    'Original strategy income': '原策略收益',
    'stocks + original strategy income': '个股+原策略叠加收益',
    'stocks + income after optimization': '个股+优化后叠加收益',

    'Original max annualized income': 'Original maximum annualized return',
    'max Annualized income after optimization': 'Maximum annualized profit after optimization',

    'queue': 'Waiting...',

    'DayTradeOnly': 'Day trade only',

    'startConnectSysEngine': 'Connecting to service...',

    'connectToSysEngineSucc': 'Connected to service.',
    'connectToSysEngineFail': 'Failed to connect to system engine',
    'DisconnectToSysEngine': 'System engine disconnected',

    'connectToSysEngineError': 'Connection system engine error',

    'DisconnectSysEngineTryagain': 'Connecting to services...',

    'loginRequestSucc': 'Logged in to service.',
    'logintRequestFail': 'Failed to log in to the system service',

    'deployStrategySubmitFail': 'Failed to submit deployment strategy',
    'deployStrategyFail': 'Failed to deploy strategic trading',

    'Multi-dimensionalOptimization': '4D optimization',
    'ScrollOptimization': 'Scroll optimization',

    'chooseBroker': 'Brokerage',
    'accountType': 'Account type',
    'requiredSteps': 'Steps',
    'cashAccount': 'Cash',
    'financingAccount': 'Margin',

    'start': 'Start',
    'stop': 'Stop',

    'running': 'Running',
    'waiting': 'Not started',
    'stopping': 'stopping',

    'want.delete.trade': 'Are you want to undeploy the strategy?',
    'remove.trade.success': 'Undeployed [symbol] strategy {num}',

    'simulated trading limit': 'Only up to <span class="common-loading-icon">10</span> simulated trades can be run at the same time!',
    'simulated trading limit prompt': 'To continue creating new paper trades, please go to "My Simulation" and delete a running paper trade.',

    'buyingPowerRequried': 'Minimum buying power required',
    'tradeLiveInfo01': '1. Run IB TWS,configure and allow socket connection.',
    'tradeLiveInfo02': '2. Download Quancept IB order agent.',
    'tradeLiveInfo03': '3. Run Quancept IB order agent,connect to IB TWS.',

    'minimumPositionRequired': 'Minimum position required',
    'downloadQuanceptAgent': 'Download "Quancept IB order agent"',

    'share': '{num} share',

    'newRealTradeSucc': 'Strategy is deployed for live trading.',
    'checkLiveTradeStatus': 'Check status at ',
    'checkLiveTradeStatusUrl': '”My trading -> My live trading“',

    'targetDistance': 'Take profit',
    'stopDistance': 'Stop loss',
    'maxHoldingPeriod': 'Holding period',
    'minute': 'Minutes',
    'day': ' Days',

    'original': 'Original',
    'none': 'None',

    'Original strategy': 'Original strategy',

    'stockStrategy': 'Individual stocks strategy',
    'generalStrategy': 'General strategy',

    'unrealized': 'Unrealized',

    'rollingStrategy': 'Consistent return',
    'getRollingStrategy': 'Explore',

    'queryRequestSucc': 'Request submitted',
    'queryingConsuming': 'Query, time-consuming{num}s',
    'queryingCompletedConsuming': 'Exploration completed',//，耗时{num}s',

    'queryFail': 'Error in request query，Error: {num}',
    'todayQueryNumberRunOut': 'Today\'s stock query quota has been used up',
    'Querying': 'Querying',
    'Researching': 'Researching',
    'query time': 'Query time',
    'query interval': 'Test period',

    'incomeList': 'Performance by strategy',
    'In-sample': 'In-sample',
    'Out-sample': 'Out-sample{num}',

    'query prompt': 'Exploration has begun. Please check back in one hour.',
    'No strategy found for this security': 'No strategy found for this security',

    'strategy id': 'Strategy',
    'category': 'Category',

    'Basic Information': 'Explore strategies with consistent return',

    'filter': 'Filter',
    'check': 'Check',

    'queryTime': 'Datetime',
    'Overnight position': 'Overnight position',

    'Cross Days': 'Yes',
    'within days': 'No',

    'Return': 'Return',
    'operation': '',

    'Buying power to allocate': 'Buying power to allocate',
    'Buying power to allocate tips': 'The allocation of buying power cannot be less than the minimum buying power',

    'stopped': 'Stopped',
    'Undeploy': 'Undeploy',

    'tbLogin': 'Trade account',
    'Capital used': 'Capital used',

    'No strategy available for aymbol': 'No strategy available for {symbol}',

    'login td account': 'Login to your TD Ameritrade account',
    'Failed to get auth url': 'Failed to get TD Ameritrade certified URL address',
    'Authentication is normal': 'TD Ameritrade account verification is normal, no need to log in again',
    'Authenticate tdameritrade account': 'Please log in to the TD Ameritrade account for verification',
    'tdameritrade account authentication is about to expire': 'TD Ameritrade account verification is about to expire, please log in again for verification',
    
    'new filter': 'New filter',
    'my filter': 'My filter',

    'edit filter': 'Update filter',
    'remove filter': 'Remove filter',

    'save filter': 'Save filter',
    'upstream filter': 'Upstream filter',

    'filter.name.placeholder': 'Give a good name (1-100 bytes)', //tod
    'filter.name.format': 'letter case, numbers only',
    'Filter name cannot be empty': 'Filter name cannot be empty',
    'filter.name.already.exists': 'Filter name already exists. Try another name.',

    'make.sure.delete.filter': 'Are you sure you want to delete the filter ',

    'alertIntervalError': 'The alert interval must be great than 300 sec',

    'new.filter.success': 'New filter succeeded',
    'update.filter.success': 'Update filter succeeded',
    'delete.filter.success': 'delete filter succeeded',

    'datetime': 'Datetime',

    'update scan': 'Update scan',

    'compact': 'Compact',
    'detailed': 'Detailed',
    'count': 'Count',

    'downloads.alerts': 'Downloads alerts',

    'portfolioError': 'Portfolio opt , Error: {errorCode}',
    'my.portfolio': 'My portfolio',

    'Whether to adjust the warehouse': 'Whether to adjust the warehouse',

    'Daily': 'Daily',
    '60Min': '60Min',
    'Month': 'Month',
    'Week': 'Week',
    'Hour': 'Hour',

    'startPortfolio': 'Start Portfolio',

    'No Portfolio optimization results': 'No Portfolio optimization results',

    'Maximizing returns': 'Maximizing returns',
    'Minimize variance': 'Minimize variance',
    'Benchmarking income': 'Benchmarking income',

    'Portfolio opt info': 'Portfolio optimization information',

    'want.delete.portfolio': 'Sure you want to delete the optimization?',

    'fromDate': 'From date',
    'toDate': 'To date',
    'barInterval': 'Interval',
    'tradePeriod': 'Trade period',

    'backtestItems': '',


}
export default en_US;